<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <span style="font-size: 48px">Votre Panier</span>
            </v-flex>
            <v-flex xs12 class="mt-4">
                <v-layout row style="border-bottom: 2px solid grey" wrap align-center class="pb-2" v-for="(item, index) in shoppingCart" :key="index">
                    <v-flex xs12 md3>
                        <v-card style="border-radius: 10px">
                            <v-card-media :src="item.productImg" height="150px"></v-card-media>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="text-xs-center">
                        <span style="font-size: 20px">{{item.productName}}</span>
                    </v-flex>
                    <v-flex xs12 md1 class="text-xs-center pt-4">

                             <v-text-field
                                     solo
                                     v-model="item.qty"
                                     type="number"
                                     color="primary"
                             >
                             </v-text-field>

                    </v-flex>
                    <v-flex xs12 md2 class="text-xs-center">
                        <span style="font-size: 20px">{{item.productPrice * item.qty | currency}}</span>
                    </v-flex>
                    <v-flex xs12 md2 class="text-xs-center">
                        <v-btn class="primary" icon dark large @click="removeItem(item)"><v-icon>delete</v-icon></v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row style="border-bottom: 2px solid grey" wrap align-center class="pb-2">
                    <v-flex xs12 md3>
                        <v-btn class="primary" @click="saveShoppingCart(authUserDetails.id)" medium dark><b>Enregistrer le panier</b></v-btn>
                    </v-flex>
                    <v-flex xs12 md4 class="text-xs-center">
                    </v-flex>
                    <v-flex xs12 md1 class="text-xs-center">
                        <span style="font-size: 36px">Total</span>
                    </v-flex>
                    <v-flex xs12 md2 class="text-xs-center">
                        <span style="font-size: 20px">{{Total | currency}}</span>
                    </v-flex>
                    <v-flex xs12 md2 class="text-xs-center">
                        <v-btn class="success" @click="placeOrder(Total)" medium dark><b>Confirmer</b><v-icon right>check</v-icon></v-btn>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    export default {
      computed: {
        authUserDetails () {
          return this.$store.getters.user
        },
        shoppingCart () {
          return this.$store.getters.shoppingCart
        },
        Total () {
          var total = 0
          this.$store.getters.shoppingCart.forEach(item => {
            total += (item.productPrice * item.qty)
          })
          return total
        }
      },
      data () {
        return {}
      },
      methods: {
        removeItem (payload) {
          this.$store.dispatch('REMOVE_ITEM', payload)
        },
        saveShoppingCart (authUserDetails) {
          this.$store.dispatch('SAVE_SHOPPING_CART', authUserDetails)
        },
        placeOrder (payload) {
          this.$store.dispatch('PLACE_ORDER', payload)
        }
      },
      mounted () {
        this.saveShoppingCart()
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/utilisateur/shoppingCart/Index.vue